import * as z from 'zod';

import { agreementStatusQuerySchema } from './agreement-status-schema';
import { pipelineQuerySchema } from './agreements-pipeline-schemas';

export const agreementQueryLinkerSchema = z.object({
  id: z.number(),
  pipeline: pipelineQuerySchema,
  agreement_date: z.string().min(1),
  expiry_date: z.string().min(1),
  agreement_id: z.string(),
  status: agreementStatusQuerySchema.nullable(),
  opt_in_total: z.number(),
  monthly_recurring_total: z.number(),
  annual_recurring_total: z.number(),
  execution_date: z.string().nullish(),
  parent_id: z.number().nullable(),
});

export type AgreementQueryLinkerSchema = z.infer<typeof agreementQueryLinkerSchema>;
